"use client";

import React from "react";

//types
import { CardListOccupationProps } from "@/types";

//Style
import * as S from "./styles";

const CardListOccupation: React.FC<CardListOccupationProps> = ({
  className,
  children,
  titleCard,
}) => {
  return (
    <S.BoxCard className={className}>
      <S.TitleCard>{titleCard}</S.TitleCard>
      {children}
    </S.BoxCard>
  );
};

export default CardListOccupation;
